import { AsyncPipe, NgFor, NgIf } from '@angular/common';
import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { CustomisableVariables } from '@shared/models/customisable-variables';
import { MenuList } from '@shared/models/menu-list';
import { FragmentPipe } from '@shared/pipes/fragment.pipe';
import { CustomisableVariablesService } from '@shared/services/customisable-variables.service';
import { SiteMap, SitemapService } from '@shared/shared/services/sitemap.service';
import { NavigationService } from 'core/services/navigation.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'ten-sitemap-footer',
  templateUrl: './sitemap-footer.component.html',
  styleUrls: ['./sitemap-footer.component.scss'],
  standalone: true,
  imports: [AsyncPipe, NgFor, NgIf, RouterModule, TranslateModule, FragmentPipe, MatIconModule],
})
export class SitemapFooterComponent {
  public mainNavLinks$: Observable<MenuList[]>;
  public siteMap$: Observable<SiteMap>;
  public customVariables$: Observable<CustomisableVariables> = this.customVariablesService.variables;

  constructor(
    private navigationService: NavigationService,
    private sitemapService: SitemapService,
    private customVariablesService: CustomisableVariablesService
  ) {
    this.mainNavLinks$ = this.navigationService.getNavigationLinks();
    this.siteMap$ = this.sitemapService.siteMap$;
  }
}
